import Mock from '@/mocks/Mock'
import News from '@/models/News'
import NewsItem from '@/models/NewsItem'

export default class NewsMock extends Mock<News> {
  constructor() {
    super('news')
  }

  fetch(transactId: string) {
    console.log(transactId)

    return new News(this.data)
  }

  history(transactId: string, date: Date) {
    console.log(transactId, date)

    return new News(this.data)
  }

  createOrUpdate(transactId: string, newsItem: NewsItem) {
    console.log(transactId, newsItem)

    return new News(this.data)
  }

  delete(transactId: string, id: number) {
    console.log(transactId, id)

    return new News(this.data)
  }
}
